<template>
<section id="main">
  <div class="container">
    <div class="row gtr-200">
      <div class="col-12 about-us">
        <!-- Highlight -->
        <section class="box highlight">
          <header>
            <h2>{{ $t('aboutus_eslogan') }}</h2>
          </header>
          <p>
            {{ $t('about_description') }}
          </p>
        </section>
        <gmap-map
            :center="center"
            :zoom="zoom"
            style="width:100%;  height: 400px;"

          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="showMarkerModal"
            />
          </gmap-map>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'AboutUs',
  data () {
    return {
      center: { lat: 40.434091, lng: -3.5372291 },
      markers: [{
        position: { lat: 40.434373, lng: -3.537517 },
        visible: true,
        title: 'Radiadores Coslada (ver foto)'
      }],
      places: [],
      currentPlace: null,
      zoom: 18
    }
  },
  methods: {
    showMarkerModal: function () {
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  margin-bottom: 2em;
}
</style>
